"use strict";
/* RIPPED FROM https://github.com/andrewbranch/merge-props/blob/master/src/index.ts */
Object.defineProperty(exports, "__esModule", { value: true });
const resolvers = {
    className: (target, key, value) => {
        target.className = [target.className, value].join(' ').trim();
    },
    style: (target, key, value) => {
        target.style = Object.assign(Object.assign({}, target.style), value);
    },
    typeofFunction: (target, key, value) => {
        // eslint-disable-next-line @typescript-eslint/ban-types
        const oldFn = target[key];
        target[key] = oldFn ? (...args) => {
            oldFn(...args);
            // eslint-disable-next-line @typescript-eslint/ban-types
            value(...args);
        } : value;
    },
};
function pushProp(target, key, value) {
    const resolverKey = typeof value === 'function' ? 'typeofFunction' : key;
    const resolver = resolvers[resolverKey];
    if (resolver) {
        resolver(target, key, value);
    }
    else if (
    // skip merging undefined values
    value === undefined
        // skip if both value are the same primitive value
        || (typeof value !== 'object' && value === target[key])) {
        // do nothing
    }
    else if (!(key in target)) {
        target[key] = value;
    }
    else {
        throw new Error(`Didn’t know how to merge prop '${key}'. `
            + 'Only \'className\', \'style\', and event handlers are supported');
    }
}
/**
 * Merges sets of props together:
 *  - duplicate `className` props get concatenated
 *  - duplicate `style` props get shallow merged (later props have precedence for conflicting rules)
 *  - duplicate functions (to be used for event handlers) get called in order from left to right
 * @param props Sets of props to merge together. Later props have precedence.
 */
function mergeProps(...props) {
    if (props.length === 1) {
        return props[0];
    }
    return props.reduce((merged, ps) => {
        for (const key in ps) {
            pushProp(merged, key, ps[key]);
        }
        return merged;
    }, {});
}
exports.default = mergeProps;
